import type {
  ICompany,
  ICompanyIdentityProvider,
  ICompanyValue,
  ICompanyValueGroup,
} from '@/types/Data'
import type {
  ICreateCompany,
  IGetCompanyValueList,
  IPaging,
  IPayloadCompanyValue,
  IPayloadCompanyValueGroup,
  IUpdateCompany,
} from '@/types/Request'
import { JsonToFormData } from '@/utils-ts'
import BaseService from '../BaseService'

export default class CompanyServices extends BaseService {
  GetCompanyInfo() {
    return this.GET<ICompany>(this.PATHS.GET_COMPANY_INFO, { ByJwt: true })
  }

  GetAllCompanyList(payload: IPaging) {
    return this.GET<ICompany[]>(this.PATHS.GET_ALL_COMPANY_LIST, { ...payload, ByJwt: true })
  }

  GetCompanyPublicInfo(WebDomain: string) {
    return this.GET<ICompany>(this.PATHS.GET_COMPANY_PUBLIC_INFO, { WebDomain })
  }

  CreateCompany(data: ICreateCompany) {
    return this.POST<void>(this.PATHS.CREATE_COMPANY, data)
  }

  UpdateCompany(data: IUpdateCompany) {
    return this.POST<ICompany>(this.PATHS.UPDATE_COMPANY, JsonToFormData(data))
  }

  DeleteCompanyBanner(Id: string) {
    return this.DELETE<void>(this.PATHS.DELETE_COMPANY_BANNER, { Id })
  }

  DeleteCompanyBackground(Id: string) {
    return this.DELETE<void>(this.PATHS.DELETE_COMPANY_BACKGROUND, { Id })
  }

  DeleteInactiveImage(Id: string) {
    return this.DELETE<void>(this.PATHS.DELETE_INACTIVE_IMAGE, { Id })
  }

  DeletePushLogoImage(Id: string) {
    return this.DELETE<void>(this.PATHS.DELETE_PUSH_LOGO_IMAGE, { Id })
  }

  DeleteFourWeekImage(Id: string) {
    return this.DELETE<void>(this.PATHS.DELETE_FOURWEEK_IMAGE, { Id })
  }

  GetCompanyValueList(payload: IGetCompanyValueList) {
    return this.GET<ICompanyValue[]>(this.PATHS.GET_COMPANY_VALUE_LIST, {
      ...payload,
      IsAdmin: true,
    })
  }

  CreateCompanyValue(data: IPayloadCompanyValue) {
    return this.POST<ICompanyValue>(this.PATHS.CREATE_COMPANY_VALUE, JsonToFormData(data))
  }

  UpdateCompanyValue(data: IPayloadCompanyValue) {
    return this.POST<ICompanyValue>(this.PATHS.UPDATE_COMPANY_VALUE, JsonToFormData(data))
  }

  DeleteCompanyValue(Id: string) {
    return this.DELETE<void>(this.PATHS.DELETE_COMPANY_VALUE, { Id })
  }

  GetCompanyValueGroupList(payload: IPaging) {
    return this.GET<ICompanyValueGroup[]>(this.PATHS.GET_COMPANY_VALUE_GROUP_LIST, payload)
  }

  CreateCompanyValueGroup(data: IPayloadCompanyValueGroup) {
    return this.POST<ICompanyValueGroup>(
      this.PATHS.CREATE_COMPANY_VALUE_GROUP,
      JsonToFormData(data),
    )
  }

  UpdateCompanyValueGroup(data: IPayloadCompanyValueGroup) {
    return this.POST<ICompanyValueGroup>(
      this.PATHS.UPDATE_COMPANY_VALUE_GROUP,
      JsonToFormData(data),
    )
  }

  DeleteCompanyValueGroup(Id: string) {
    return this.DELETE<void>(this.PATHS.DELETE_COMPANY_VALUE_GROUP, { Id })
  }

  GetCompanyIdentityProviderList(CompanyCode: string) {
    return this.GET<ICompanyIdentityProvider[]>(this.PATHS.GET_COMPANY_IDENTITY_PROVIDER_LIST, {
      CompanyCode,
    })
  }
}
